import { useContext } from 'react';
import { PopmenuConfigContext } from '../../../utils/withPopmenuConfig';
import type { PopmenuConfigType } from '../../types/EatAppProps';

export const usePopmenuConfig = () => {
  const popmenuConfig = useContext(PopmenuConfigContext);
  return popmenuConfig as PopmenuConfigType;
};
